"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdminStickerActivityDto = exports.AdminStickerDetailDto = exports.AdminStickerDto = exports.AdminStickerVenueDto = exports.AdminStickerAuthorDto = void 0;
const swagger_1 = require("@nestjs/swagger");
class AdminStickerAuthorDto {}
exports.AdminStickerAuthorDto = AdminStickerAuthorDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerAuthorDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerAuthorDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerAuthorDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerAuthorDto.prototype, "imageUrl", void 0);
class AdminStickerVenueDto {}
exports.AdminStickerVenueDto = AdminStickerVenueDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerVenueDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerVenueDto.prototype, "name", void 0);
class AdminStickerDto {}
exports.AdminStickerDto = AdminStickerDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerDto.prototype, "imageUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminStickerDto.prototype, "caption", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], AdminStickerDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true,
  description: 'Null when the author kept the moment on their profile.'
}), __metadata("design:type", Object)], AdminStickerDto.prototype, "expiresAt", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminStickerDto.prototype, "isExpired", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminStickerDto.prototype, "isPinned", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], AdminStickerDto.prototype, "likeCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'Open (not yet reviewed) user reports.'
}), __metadata("design:type", Number)], AdminStickerDto.prototype, "openReportCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminStickerAuthorDto
}), __metadata("design:type", AdminStickerAuthorDto)], AdminStickerDto.prototype, "author", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: AdminStickerVenueDto
}), __metadata("design:type", AdminStickerVenueDto)], AdminStickerDto.prototype, "venue", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminStickerDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], AdminStickerDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Boolean)], AdminStickerDto.prototype, "isFlagged", void 0);
class AdminStickerDetailDto extends AdminStickerDto {}
exports.AdminStickerDetailDto = AdminStickerDetailDto;
class AdminStickerActivityDto extends AdminStickerDto {}
exports.AdminStickerActivityDto = AdminStickerActivityDto;
//# sourceMappingURL=AdminSticker.dto.js.map